import { useRouter } from "next/router";

import { HOME_ROUTE } from "@/common/static/routes.static";
import { HeaderMobileCategoriesButton } from "@/features/home-categories/components/HeaderMobileCategoriesButton";
import { useHomepageMobileCategories } from "@/features/home-categories/hooks/useHomepageMobileCategories";

export const HeaderMobileCategories = () => {
  const { asPath } = useRouter();

  const { categories } = useHomepageMobileCategories();

  if (asPath !== HOME_ROUTE || !categories) {
    return null;
  }

  return (
    <div className="flex justify-between gap-x-1 md:hidden">
      {categories.map(category => (
        <HeaderMobileCategoriesButton
          key={category.id}
          label={category.title}
          icon={category.svgIcon}
          url={category.listingPage.url}
        />
      ))}
    </div>
  );
};
